// src/firebase/config.js
// ─────────────────────────────────────────────────────────────────
// STEP 1: Go to https://console.firebase.google.com
// STEP 2: Create a project named "rka-portal"
// STEP 3: Add a Web App, copy the firebaseConfig object below
// STEP 4: Enable these in the Firebase Console:
//   • Authentication → Sign-in method → Email/Password
//   • Firestore Database → Create in production mode
//   • Storage → Get started
// STEP 5: Replace the placeholder values below with your real config
// ─────────────────────────────────────────────────────────────────

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDbtd3ZWq1Q2nIiJinTUwmDK31g5hwewDc",
  authDomain: "rka-portal.firebaseapp.com",
  projectId: "rka-portal",
  storageBucket: "rka-portal.firebasestorage.app",
  messagingSenderId: "1050066114422",
  appId: "1:1050066114422:web:a1ccfcca511e05d5ad8c57",
  measurementId: "G-XXTCGV1HJJ"
};

const app = initializeApp(firebaseConfig);

export const auth    = getAuth(app);
export const db      = getFirestore(app);
export const storage = getStorage(app);
export default app;
